import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BookingPage from './pages/BookingPage';
import AdminPanel from './pages/AdminPanel';
import CheckBooking from './pages/CheckBooking';
import PaymentSuccess from './pages/PaymentSuccess';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/reservar" element={<BookingPage />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/consultar-turno" element={<CheckBooking />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;